export default () => {
    const nodeSelectors = {
        container: '[js-plan-map="container"]',
        map: '[js-plan-map="map"]',
    }

    const parent = document.querySelector(nodeSelectors.container);
    const child = document.querySelector(nodeSelectors.map);

    function init() {
        if (!document.querySelector(nodeSelectors.container)) {
            return
        }

        window.addEventListener("load", function () {
            centerContainer()
        });

        window.addEventListener("resize", function () {
            centerContainer()
        });
    }

    function centerContainer() {
        const scrollLeft = (child.offsetWidth - parent.clientWidth) / 2;
        parent.scrollLeft = scrollLeft;
    }

    function centerContainerByChild(element) {
        if (!element) return;
        const scrollLeft = element.offsetLeft - parent.clientWidth / 2 + element.clientWidth / 2;

        parent.scrollLeft = scrollLeft;
    }

    return Object.freeze({
        init,
        centerContainerByChild
    })
}